const LitersToGllRate = 3.7854;
const LitersToBblRate = 159;

const GllToBblRate = LitersToBblRate/LitersToGllRate;

/**
 * Converts Liters to Gallons
 */
export function convertLitersToGll(value: number): number {
    return value * LitersToGllRate;
}

/**
 * Converts Liters to Barrels
 */
export function convertLitersToBbl(value: number): number {
    return value * LitersToBblRate;
}

/**
 * Converts Gallons to Barrels
 */
export function convertGllToBbl(value: number): number {
    return value * GllToBblRate;
}

/**
 * Converts Gallons to Liters
 */
export function convertGllToLiters(value: number): number {
    return value / LitersToGllRate;
}

/**
 * Converts Barrels to Liters
 */
export function convertBblToLiters(value: number): number {
    return value / LitersToBblRate;
}

/**
 * Converts Barrels to Gallons
 */
export function convertBblToGll(value: number): number {
    return value / GllToBblRate;
}